import { useFormik } from 'formik';
import { FC } from 'react';
import * as Yup from 'yup';

import { Dayjs } from 'dayjs';

import { ViewResolver } from '@Components/ViewResolver';
import UnlockPricingMobile from './mobile/UnlockPricingMobile';

import UnlockPricingDesktop from './desktop/UnlockPricingDesktop';

export type UnlockPricingFormValues = {
  expectedAmount: number | null;
  expiryDate: string | null;
  expiryTime: Dayjs | null;
  remarks: string | null;
};
export interface UnlockPricingDialogProps {
  isOpen: boolean;
  initialPricing: UnlockPricingFormValues;
  onSubmit: (values: UnlockPricingFormValues) => void;
  onCancel: () => void;
}

const UnlockPricingSchema = Yup.object().shape({
  expectedAmount: Yup.number().nullable(),
  expiryDate: Yup.string().nullable(),
  expiryTime: Yup.string().nullable(),
  remarks: Yup.string().max(20).required('Value is required'),
});
const UnlockPricingDialog: FC<UnlockPricingDialogProps> = ({
  initialPricing,
  isOpen,
  onSubmit,
  onCancel,
}) => {
  const formik = useFormik({
    initialValues: initialPricing,
    // enableReinitialize: true,
    onSubmit: (values: UnlockPricingFormValues) => {
      onSubmit?.(values);
    },
    validationSchema: UnlockPricingSchema,
  });

  return (
    <ViewResolver
      desktop={
        <UnlockPricingDesktop
          formik={formik}
          isOpen={isOpen}
          onCancel={onCancel}
        />
      }
      mobile={
        <UnlockPricingMobile
          formik={formik}
          isOpen={isOpen}
          onCancel={onCancel}
        />
      }
    />
  );
};

export default UnlockPricingDialog;
